import {
  Box,
  Heading,
  mdBumps,
  Notification,
  NotificationProps,
  Typo,
} from '@wrisk/ui-components'
import { TFunctionDetailedResult } from 'i18next'
import React, { FC } from 'react'

import {
  TKeyBuilder,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'
import { WriskTrans } from '../../../organisms/trans'
import { useProposal } from '../ProposalProvider'

interface PageNotificationProps extends NotificationProps {
  tKey: TKeyBuilder
}

type ContentDetailedResult = TFunctionDetailedResult<{
  header?: TFunctionDetailedResult
  content: TFunctionDetailedResult
}>

type NotificationDetailedResult = TFunctionDetailedResult<
  TFunctionDetailedResult | ContentDetailedResult[] | null
>

export const PageNotification: FC<PageNotificationProps> = ({ tKey, ...props }) => {
  const { t } = useWriskTranslation()

  const { proposal } = useProposal()

  const header = t(tKey('notification', 'header'), { defaultValue: null })
  const content = t(
    [
      tKey('notification', 'sources', proposal.source ?? 'default'),
      tKey('notification', 'content'),
    ],
    {
      defaultValue: null,
      returnDetails: true,
      returnObjects: true,
    },
  ) as NotificationDetailedResult

  if (!content.res) return null

  return (
    <Notification
      variant='default'
      type='standalone'
      flexDirection='column'
      alignItems='flex-start'
      {...props}
    >
      {header && (
        <Heading variant='h3' typoSize='md' mb={4}>
          {header}
        </Heading>
      )}
      <Box>
        {Array.isArray(content.res) ? (
          <Box
            display='flex'
            gap={mdBumps}
            flexDirection='column'
            alignItems='flex-start'
          >
            {content.res.map((item, index) => (
              <Box key={index}>
                {item.res.header?.res && (
                  <Heading variant='h4'>{item.res.header.res}</Heading>
                )}
                <Typo whiteSpace='pre-wrap'>
                  <WriskTrans t={t} i18nKey={item.res.content.exactUsedKey} />
                </Typo>
              </Box>
            ))}
          </Box>
        ) : (
          <Typo whiteSpace='pre-wrap'>
            <WriskTrans t={t} i18nKey={content.exactUsedKey} />
          </Typo>
        )}
      </Box>
    </Notification>
  )
}
